var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_cheart_ct"},[_c('el-card',{staticStyle:{"height":"100%"}},[_c('p',[_vm._v("企业注册地与经营地情况统计")]),_c('div',{ref:"ehachrValue",staticClass:"ehcartds",staticStyle:{"height":"90%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }